import { notificationMessageVar } from 'modulesCommon/store'
import { useUpdateChartSourceItemMutation } from '../graphql/mutations/updateChartSourceItem.types'
import { useLoading, useServerError } from 'shared/hooks'

export const useChartSourceUpdate = () => {
  const [updateChartSourceItem, { loading: isUpdateLoading, error: isUpdateError }] = useUpdateChartSourceItemMutation(
    {
      onCompleted: () => {
        notificationMessageVar({
          type: 'success',
          message: 'Chart Source successfully updated.',
          title: 'Success'
        })
      },
    }
  )

  useLoading({ isLoading: isUpdateLoading })
  useServerError([isUpdateError])

  return {
    updateChartSourceItem,
    isUpdateLoading,
    isUpdateError
  }
}
